export const publishClosedRacingLines = async ({ auth, lineId = '' }) => {
  if (!auth?.app) throw new Error('Sign-in is still loading. Please try again.')
  const user = auth.app.auth().currentUser || auth.user
  if (!user || user.isAnonymous) throw new Error('Sign in before publishing racing lines.')
  if (typeof user.getIdToken === 'function') await user.getIdToken(true)

  const functionsInstance = auth.app.functions && auth.app.functions()
  if (!functionsInstance || typeof functionsInstance.httpsCallable !== 'function') {
    throw new Error('Racing line publishing is temporarily unavailable.')
  }
  const publish = functionsInstance.httpsCallable('canCreateRacingLine')
  const result = await publish({
    operation: 'publishClosedRacingLines',
    payload: lineId ? { lineId } : {},
  })
  return result?.data || { publishedCount: 0 }
}

export const createFreeManualRacingLine = async ({ auth, track = {} }) => {
  if (!auth?.app) throw new Error('The editor is still loading. Please try again.')

  let user = auth.app.auth().currentUser || auth.user
  if (!user) {
    if (typeof auth.signInAnonymouslyAndGetUser !== 'function') {
      throw new Error('The editor could not start a private browser session.')
    }
    user = await auth.signInAnonymouslyAndGetUser()
  }

  if (typeof user.getIdToken === 'function') await user.getIdToken(true)

  const functionsInstance = auth.app.functions && auth.app.functions()
  if (!functionsInstance || typeof functionsInstance.httpsCallable !== 'function') {
    throw new Error('Racing line creation is temporarily unavailable.')
  }

  const createManualLine = functionsInstance.httpsCallable('canCreateRacingLine')
  const result = await createManualLine({
    operation: 'createManualRacingLine',
    payload: {
      name: track.name || '',
      placeId: track.placeId || '',
      url: track.url || '',
      lat: Number(track.lat),
      lng: Number(track.lng),
      zoom: Number(track.zoom || 19),
    },
  })

  if (!result?.data?.lineId) throw new Error('The racing line could not be created.')
  return result.data
}
